import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/volumes';
export function VolumesSection() {
  return <section className="bg-canvas px-5 py-20 md:py-28" data-id="element-202" data-mp="31rnupotqra08">
      <div className="mx-auto max-w-6xl" data-id="element-203" data-mp="2mvew8phod0ov">
        <SectionHeading title="5 volúmenes. Un solo sistema." subtitle="Cada volumen cumple una función específica y juntos forman una biblioteca completa para educación y promoción de la salud." data-id="element-204" data-mp="2munae6dvqhbs" />
        <ol className="mt-14 border-b border-line" data-id="element-205" data-mp="2e1a9oi9kqbf5">
          {volumes.map(v => <li key={v.number} className="grid gap-4 border-t border-line py-8 md:grid-cols-[88px_1fr] lg:grid-cols-[88px_1fr_260px] lg:items-start lg:gap-8" data-id="element-206" data-mp="2iud56vxwvuxz">
              <span className="text-4xl font-black leading-none tracking-tight text-accent tabular-nums md:text-5xl" data-id="element-207" data-mp="293i6ut7e54w6">{v.number}</span>
              <div data-id="element-208" data-mp="1v3h93mmfadkx">
                <h3 className="text-xl font-black uppercase leading-tight text-ink md:text-2xl" data-id="element-209" data-mp="1v492qrwgm18k">{v.title}</h3>
                <p className="mt-3 max-w-2xl text-base leading-relaxed text-muted md:text-lg" data-id="element-210" data-mp="1z4j7y2cfgnmd">{v.body}</p>
              </div>
              <p className="text-xs font-extrabold uppercase leading-relaxed tracking-wider text-accent md:col-start-2 lg:col-start-auto lg:pt-1.5 lg:text-right md:text-sm" data-id="element-211" data-mp="1fl39xs6jy3pz">
                {v.flow.join(' → ')}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}